import { getSolarRecommand } from '@/service/solar-calculator';
import { useGlobal } from '@/utils/useGlobal';
import InstallationPopup from '@elem/compCommon/ProductConstructor/BriefGuide/InstallationPopup';
import { FormatMoneyLocal } from '@elem/compCommon/ShopifyShoppingCart/const';
import { createImgsCallbackBuy } from '@elem/compPage/DP3/components/ThirdLinks';

import ClipboardJS from 'clipboard';
import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { saveCookieForShopify, saveAICookieForShopify } from '@elem/ui-common/utils/CookieForShopify';

export default function BundleNA() {
    const { useState, useEffect, useLang, useRouter, gtm, Link } = useGlobal();
    const { t } = useLang('dp3.crowdfunding.bundle');
    const { t: s } = useLang('shared.product.bundles');
    const { t: c } = useLang('shared.product.info');
    const { locale, query } = useRouter();
    const [showSteps, setShowSteps] = useState(false);
    const [copyed, setCopyed] = useState(false);
    const [tipShow, setTipShow] = useState(false);

    const bundles = [
        {
            title: t('item1_title'),
            name: t('item1_name'),
            power: t('item1_power'),
            desc: t('item1_desc'),
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719036493490/a1.png',
            link_more: `https://${locale}.ecoflow.com/products/delta-pro-3-portable-power-station`,
            productId: (() => {
                const localMap: any = {
                    us: '7185477075017',
                    ca: '8231332380826',
                };
                return localMap[locale] || undefined;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41385721004105',
                    ca: '44902384599194',
                };
                return localMap[locale] || undefined;
            })(),
            coupon: 'DP3LAUNCH',
            subs: [
                {
                    name: t('item1_sub2_name'),
                    // img: '/responsive/picture/common-products/shp2_front.png',
                    parentVariantId: (() => {
                        const localMap: any = {
                            us: '41385721004105',
                            ca: '44902384599194',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    productId: (() => {
                        const LocalMap: any = {
                            us: '7213436534857',
                            ca: '8243525550234',
                        };
                        return LocalMap[locale] || LocalMap.us;
                    })(),
                    variantId: (() => {
                        const LocalMap: any = {
                            us: '41435086618697',
                            ca: '44936116961434',
                        };
                        return LocalMap[locale] || LocalMap.us;
                    })(),
                },
                {
                    name: t('item1_sub3_name'),
                    // img: '/responsive/picture/common-products/TS306A.png',
                    parentVariantId: (() => {
                        const localMap: any = {
                            us: '41385721004105',
                            ca: '44902384599194',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    productId: (() => {
                        const LocalMap: any = {
                            us: '7213639696457',
                            ca: '8243535184026',
                        };
                        return LocalMap[locale] || LocalMap.us;
                    })(),
                    variantId: (() => {
                        const LocalMap: any = {
                            us: '41436110389321',
                            ca: '44936175386778',
                        };
                        return LocalMap[locale] || LocalMap.us;
                    })(),
                },
                {
                    name: t('item1_sub4_name'),
                    // img: '/responsive/picture/common-products/TS306A.png',
                    parentVariantId: (() => {
                        const localMap: any = {
                            us: '41385721004105',
                            ca: '44902384599194',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    productId: (() => {
                        const LocalMap: any = {
                            us: '7213397180489',
                            ca: '8243520929946',
                        };
                        return LocalMap[locale] || LocalMap.us;
                    })(),
                    variantId: (() => {
                        const LocalMap: any = {
                            us: '41434865008713',
                            ca: '44936091435162',
                        };
                        return LocalMap[locale] || LocalMap.us;
                    })(),
                },
            ],
        },
        {
            title: t('item2_title'),
            name: t('item2_name'),
            power: t('item2_power'),
            desc: t('item2_desc'),
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719036526011/a2.png',
            link_more: `https://${locale}.ecoflow.com/products/delta-pro-3-extra-battery`,
            productId: (() => {
                const localMap: any = {
                    us: '7185557127241',
                    ca: '8231518666906',
                };
                return localMap[locale] || undefined;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41385808265289',
                    ca: '44902577242266',
                };
                return localMap[locale] || undefined;
            })(),
            subs: [
                {
                    name: t('item2_sub1_name'),
                    // img: '/responsive/picture/common-products/DPU_Battery.png',
                    parentVariantId: (() => {
                        const localMap: any = {
                            us: '41385808265289',
                            ca: '44902577242266',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    productId: (() => {
                        const LocalMap: any = {
                            us: '7213639696457',
                            ca: '8243525550234',
                        };
                        return LocalMap[locale] || LocalMap.us;
                    })(),
                    variantId: (() => {
                        const LocalMap: any = {
                            us: '41436110520393',
                            ca: '44936117026970',
                        };
                        return LocalMap[locale] || LocalMap.us;
                    })(),
                },
                {
                    name: t('item2_sub2_name'),
                    // img: '/responsive/picture/common-products/DPU_Battery.png',
                    parentVariantId: (() => {
                        const localMap: any = {
                            us: '41385808265289',
                            ca: '44902577242266',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    productId: (() => {
                        const LocalMap: any = {
                            us: '7213436534857',
                            ca: '8243520929946',
                        };
                        return LocalMap[locale] || LocalMap.us;
                    })(),
                    variantId: (() => {
                        const LocalMap: any = {
                            us: '41435086618697',
                            ca: '44936091435162',
                        };
                        return LocalMap[locale] || LocalMap.us;
                    })(),
                },
                {
                    name: t('item2_sub3_name'),
                    // img: '/responsive/picture/common-products/DPU_Battery.png',
                    parentVariantId: (() => {
                        const localMap: any = {
                            us: '41385808265289',
                            ca: '44902577242266',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    productId: (() => {
                        const LocalMap: any = {
                            us: '7213397180489',
                            ca: '8243535184026',
                        };
                        return LocalMap[locale] || LocalMap.us;
                    })(),
                    variantId: (() => {
                        const LocalMap: any = {
                            us: '41434865008713',
                            ca: '44936175386778',
                        };
                        return LocalMap[locale] || LocalMap.us;
                    })(),
                },
            ],
        },
        {
            title: t('item3_title'),
            name: t('item3_name'),
            power: t('item3_power'),
            desc: t('item3_desc'),
            link: locale === 'us' ? t('item3_link') : '',
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719036547145/a3.png',
            link_more: `https://${locale}.ecoflow.com/products/delta-pro-3-smart-home-panel-2`,
            productId: (() => {
                const localMap: any = {
                    us: '7199648972873',
                    ca: '8233477046426',
                };
                return localMap[locale] || undefined;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41410973958217',
                    ca: '44906482303130',
                };
                return localMap[locale] || undefined;
            })(),
            subs: [
                {
                    name: t('item3_sub1_name'),
                    // img: '/responsive/picture/common-products/DPU_Battery.png',
                    parentVariantId: (() => {
                        const localMap: any = {
                            us: '41410973958217',
                            ca: '44906482303130',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    productId: (() => {
                        const LocalMap: any = {
                            us: '7213639696457',
                            ca: '8243525550234',
                        };
                        return LocalMap[locale] || LocalMap.us;
                    })(),
                    variantId: (() => {
                        const LocalMap: any = {
                            us: '41436110389321',
                            ca: '44936116961434',
                        };
                        return LocalMap[locale] || LocalMap.us;
                    })(),
                },
                {
                    name: t('item3_sub2_name'),
                    // img: '/responsive/picture/common-products/DPU_Battery.png',
                    parentVariantId: (() => {
                        const localMap: any = {
                            us: '41410973958217',
                            ca: '44906482303130',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    productId: (() => {
                        const LocalMap: any = {
                            us: '7213397180489',
                            ca: '8243543441562',
                        };
                        return LocalMap[locale] || LocalMap.us;
                    })(),
                    variantId: (() => {
                        const LocalMap: any = {
                            us: '41434865008713',
                            ca: '44936213299354',
                        };
                        return LocalMap[locale] || LocalMap.us;
                    })(),
                },
            ],
        },
    ];

    if (locale === 'us') {
        bundles[2].subs.push({
            name: t('item3_sub3_name'),
            // img: '/responsive/picture/common-products/DPU_Battery.png',
            parentVariantId: (() => {
                const localMap: any = {
                    us: '41410973958217',
                };
                return localMap[locale] || undefined;
            })(),
            productId: (() => {
                const LocalMap: any = {
                    us: '7213636878409',
                };
                return LocalMap[locale] || LocalMap.us;
            })(),
            variantId: (() => {
                const LocalMap: any = {
                    us: '41436098134089',
                };
                return LocalMap[locale] || LocalMap.us;
            })(),
        });

        // const nowTime = query?.timer ? new Date(query?.timer).getTime() : new Date().getTime();
        // if (nowTime && nowTime >= new Date('2024/07/24 15:00:00 GMT+8').getTime() && nowTime < new Date('2024/09/01 15:00:00 GMT+8').getTime()) {
        //     bundles[0].subs = [];
        // }
    }

    const [cardBundles, setCardBundles] = useState(bundles);
    // 不能删，配合data-clipboard-text使用的对象
    const clipboard = typeof window !== 'undefined' ? new ClipboardJS('.dp3-crowdfunding-bundle .bundles .bundle .bundle-coupon') : null;

    const handleCalculate = (data, n: number) => {
        const tempBundles = JSON.parse(JSON.stringify(cardBundles));
        const parentIdx = tempBundles?.findIndex((bundle: any) => bundle?.variantId === data?.parentVariantId);
        if (parentIdx !== -1) {
            const subIdx = tempBundles[parentIdx]?.subs?.findIndex((sub: any) => sub?.variantId === data?.variantId && Number(sub?.inventory) > 0);
            if (subIdx !== -1) {
                const originalNum = Number(tempBundles[parentIdx].subs[subIdx]?.quantity || 0);
                tempBundles[parentIdx].totalDiscount =
                    (tempBundles[parentIdx]?.totalDiscount || tempBundles[parentIdx].discountPrice) +
                    tempBundles[parentIdx].subs[subIdx].discountPrice * (n - originalNum);
                tempBundles[parentIdx].totalOriginal =
                    (tempBundles[parentIdx]?.totalOriginal || tempBundles[parentIdx].originalPrice) +
                    tempBundles[parentIdx].subs[subIdx].originalPrice * (n - originalNum);
                tempBundles[parentIdx].subs[subIdx] = { ...data, quantity: n };
                const tempSubs = JSON.parse(JSON.stringify(tempBundles[parentIdx].subs));
                let tempLink = `https://${locale}.ecoflow.com/cart/${data.parentVariantId}:1`;
                tempSubs?.map((sub: any, k: number) => {
                    if (Number(sub?.quantity) > 0) {
                        tempLink += `,${sub.variantId}:${Number(sub?.quantity)}`;
                    }
                });
                tempBundles[parentIdx].link_buy = `${tempLink}?channel=buy_button`;
                setCardBundles(tempBundles);
            }
        }
    };

    const handleCopy = () => {
        setCopyed(true);
        setTimeout(() => {
            setCopyed(false);
        }, 3000);
    };

    const handleBuy = (bundle: any) => {
        createImgsCallbackBuy();
        let link_buy2 = bundle?.link_buy;
        link_buy2 = saveCookieForShopify(link_buy2, locale);
        saveAICookieForShopify(link_buy2, locale);

        gtm.push({
            event: 'uaEvent',
            event_name: 'checkout',
            button_name: `${s('buy_now')}_${bundle?.name}`,
        });

        window.open(link_buy2, '_blank');
    };

    const AddReduceCalc = ({ data, callback, tag }: any) => {
        const NUM_MIN = data?.min || 0;
        const NUM_MAX = data?.inventory > data?.limit && data?.limit > 0 ? data?.limit : data?.inventory > 0 ? data?.inventory : 0;
        const { useState } = useGlobal();
        const [number, setNumber] = useState(data?.quantity ?? 0);
        const [showMaxTip, setShowMaxTip] = useState(false);

        const reduceNumber = () => {
            if (number <= NUM_MIN) return false;
            setNumber(number - 1);
            callback(data, number - 1);
            try {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'bundle_remove_from_cart',
                    product_name: data?.name,
                    price: data?.discountPrice,
                    quantity: number - 1,
                    button_name: 'remove',
                    list_name: t('also_like'),
                    tag,
                });
            } catch (e) {
                console.error(e);
            }
        };

        const addNumber = () => {
            if (number >= NUM_MAX) {
                setShowMaxTip(true);
                setTimeout(() => {
                    setShowMaxTip(false);
                }, 2000);
                return false;
            }
            setNumber(number + 1);
            callback(data, number + 1);
            try {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'bundle_add_to_cart',
                    product_name: data?.name,
                    price: data?.discountPrice,
                    quantity: number + 1,
                    button_name: 'add',
                    list_name: 'You May Also Like:',
                    tag,
                });
            } catch (e) {
                console.error(e);
            }
        };

        const inputChange = (e: any) => {
            const v = e.target.value.replace(/[^0-9]/g, '');
            if (v < NUM_MIN || v > NUM_MAX) {
                return;
            }
            setNumber(Number(v));
            callback(data, Number(v));
        };

        return (
            <div className="bundle-calculator">
                <div className={number <= NUM_MIN ? 'addSubtractor-reduce disable' : 'addSubtractor-reduce'} onClick={reduceNumber}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <g className="svg-g">
                            <rect width="24" height="24" rx="12" fill="#38383D" />
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M8.24129 12.545H15.7516C15.9291 12.545 16.0749 12.4939 16.1889 12.3916C16.303 12.2893 16.3601 12.1586 16.3601 11.9996C16.3601 11.8405 16.303 11.7098 16.1889 11.6075C16.0749 11.5052 15.9291 11.4541 15.7516 11.4541H8.24129C8.06381 11.4541 7.91804 11.5052 7.80395 11.6075C7.68986 11.7098 7.63281 11.8405 7.63281 11.9996C7.63281 12.1586 7.68986 12.2893 7.80395 12.3916C7.91804 12.4939 8.06381 12.545 8.24129 12.545Z"
                                fill="#E6E6E6"
                            />
                        </g>
                    </svg>
                </div>
                {/* <div className="addSubtractor-number">{number}</div> */}
                <input className="addSubtractor-number" value={number} onChange={inputChange} />
                <div className={number >= NUM_MAX ? 'addSubtractor-add disable' : 'addSubtractor-add'} onClick={addNumber}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none">
                        <g className="svg-g">
                            <rect width="100%" height="100%" rx="12" fill="#38383D" />
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M8.24129 12.6088H11.388V15.7555C11.388 15.933 11.445 16.0788 11.5591 16.1929C11.6732 16.3069 11.819 16.364 11.9964 16.364C12.1739 16.364 12.3197 16.3069 12.4338 16.1929C12.5479 16.0788 12.6049 15.933 12.6049 15.7555V12.6088H15.7516C15.9291 12.6088 16.0749 12.5518 16.1889 12.4377C16.303 12.3236 16.3601 12.1778 16.3601 12.0004C16.3601 11.8229 16.303 11.6771 16.1889 11.563C16.0749 11.4489 15.9291 11.3919 15.7516 11.3919H12.6049V8.24519C12.6049 8.06772 12.5479 7.92194 12.4338 7.80785C12.3197 7.69376 12.1739 7.63672 11.9964 7.63672C11.819 7.63672 11.6732 7.69376 11.5591 7.80785C11.445 7.92194 11.388 8.06772 11.388 8.24519V11.3919H8.24129C8.06381 11.3919 7.91804 11.4489 7.80395 11.563C7.68986 11.6771 7.63281 11.8229 7.63281 12.0004C7.63281 12.1778 7.68986 12.3236 7.80395 12.4377C7.91804 12.5518 8.06381 12.6088 8.24129 12.6088Z"
                                fill="#E6E6E6"
                            />
                        </g>
                    </svg>
                </div>
                {showMaxTip && <p className="reach-max">{s('reach_max')}</p>}
            </div>
        );
    };

    useEffect(() => {
        const tempArr = JSON.parse(JSON.stringify(cardBundles));
        const getAsynItem = async (productId: string, variantId: string, k: number, m?: number) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        if (m >= 0) {
                            if (!tempArr[k].subs[m]?.img && res?.data?.img) {
                                tempArr[k].subs[m].img = res?.data?.img;
                            }
                            // if (res?.data?.productTitle || res?.data?.skuTitle) {
                            //     tempArr[k].subs[m].name = res?.data?.productTitle || res?.data?.skuTitle;
                            // }
                            tempArr[k].subs[m].discountPrice = res?.data?.price;
                            tempArr[k].subs[m].originalPrice = res?.data?.compareAtPrice || res?.data?.price;
                            tempArr[k].subs[m].inventory = res?.data?.inventoryQuantity ?? undefined;
                            tempArr[k].subs[m].link_buy = `https://${locale}.ecoflow.com/cart/${tempArr[k].subs[m].variantId}:1?channel=buy_button`;
                        } else {
                            if (!tempArr[k]?.img && res?.data?.img) {
                                tempArr[k].img = res?.data?.img;
                            }
                            // if (res?.data?.productTitle || res?.data?.skuTitle) {
                            //     tempArr[k].name = res?.data?.productTitle || res?.data?.skuTitle;
                            // }
                            tempArr[k].discountPrice = res?.data?.price;
                            tempArr[k].totalDiscount = res?.data?.price;
                            tempArr[k].originalPrice = res?.data?.compareAtPrice || res?.data?.price;
                            tempArr[k].totalOriginal = res?.data?.compareAtPrice || res?.data?.price;
                            tempArr[k].inventory = res?.data?.inventoryQuantity ?? undefined;
                            // tempArr[k].inventory = 4;
                            tempArr[k].link_buy = `https://${locale}.ecoflow.com/cart/${tempArr[k].variantId}:1?channel=buy_button`;
                        }
                        return resolve(res);
                    } else {
                        console.error(res?.message);
                        return reject(res?.message);
                    }
                } catch (e) {
                    console.error(e);
                    return reject(e);
                }
            });
        };

        const promises = [];
        tempArr?.map((item: any, k: number) => {
            if (item?.variantId) {
                if (item?.subs?.length > 0) {
                    promises.push(getAsynItem(item?.productId, item.variantId, k));
                    item?.subs?.map((sub: any, m: number) => promises.push(getAsynItem(sub?.productId, sub.variantId, k, m)));
                } else {
                    promises.push(getAsynItem(item?.productId, item.variantId, k));
                }
            }
        });

        // const promises = tempArr?.map((item: any, k: number) => getAsynItem(item?.productId, item.variantId, k));
        Promise.all(promises)
            .then(() => {
                setCardBundles(tempArr?.filter((list: any) => list?.inventory !== undefined));
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    return (
        <div className={`dp3-crowdfunding-bundle ${css['dp3-crowdfunding-bundle']}`}>
            <p className="title">{t('title')}</p>
            <ul className="bundles">
                {cardBundles?.map((bundle: any, k: number) => (
                    <li className="bundle" key={k}>
                        <div className="bundle-contente">
                            {bundle?.title && <p className="bundle-item-title">{bundle?.title}</p>}
                            <div className="bundle-img">
                                <EFPicture src={bundle?.img} alt={bundle?.name} />
                            </div>

                            {bundle?.name && <p className="bundle-name">{bundle?.name}</p>}
                            {bundle?.power && <p className="bundle-power">{bundle?.power}</p>}
                            {bundle?.desc && <p className="bundle-desc">{bundle?.desc}</p>}
                            {bundle?.link && (
                                <p className="bundle-link" onClick={() => setShowSteps(true)}>
                                    {bundle?.link}
                                </p>
                            )}
                            <p className="line"></p>
                            {/* {bundle?.coupon && (
                                <div className="bundle-coupon-box">
                                    <div className="bundle-coupon-off">
                                        <span className="off-text">{'$500 OFF'}</span>
                                        <span className="exclamation" onMouseEnter={() => setTipShow(true)} onMouseLeave={() => setTipShow(false)}>
                                            !
                                            <Tooltip
                                                title={'*Copy code & apply it at checkout.\n*Only valid on DELTA Pro 3 stand-alone unit.'}
                                                color={'#666'}
                                                placement={'bottom'}
                                                visible={tipShow}
                                                overlayClassName={css.tooltips}
                                            ></Tooltip>
                                        </span>
                                    </div>
                                    <div className="split"></div>
                                    <div className="bundle-coupon" data-clipboard-text={bundle?.coupon} onClick={handleCopy}>
                                        <Tooltip
                                            title={`Copied successfully`}
                                            color={'#666'}
                                            placement={'bottom'}
                                            visible={copyed}
                                            overlayClassName={css.tooltips}
                                        >
                                            {'Copy Code'}
                                        </Tooltip>
                                    </div>
                                </div>
                            )} */}
                            <p className={`also-like ${bundle?.subs?.length <= 0 ? 'hide' : ''}`}>{t('also_like')}</p>
                            <ul className="bundle-subs">
                                {bundle?.subs?.map((sub: any, m: number) => (
                                    <li className="bundle-sub" key={`${k}_${m}`}>
                                        <div className="sub-img">
                                            <EFPicture src={sub?.img} alt={sub?.name} />
                                        </div>
                                        <div className="sub-info">
                                            {sub?.name && <p className="sub-name">{sub.name}</p>}
                                            <div className="sub-control">
                                                <div className="sub-price">
                                                    <span className="sub-discount">{FormatMoneyLocal(sub?.discountPrice, locale)}</span>
                                                    {sub?.discountPrice !== sub?.originalPrice && (
                                                        <span className="sub-original">{FormatMoneyLocal(sub?.originalPrice, locale)}</span>
                                                    )}
                                                </div>
                                                <AddReduceCalc data={sub} tag={bundle?.name} callback={handleCalculate} />
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="bundle-btns">
                            <div className="total-price">
                                <span className="total-discount">{FormatMoneyLocal(bundle?.totalDiscount ?? bundle?.discountPrice, locale)}</span>
                                {bundle?.totalDiscount !== bundle?.totalOriginal && (
                                    <span className="total-original">{FormatMoneyLocal(bundle?.totalOriginal ?? bundle?.originalPrice, locale)}</span>
                                )}
                            </div>
                            {/* {locale === 'us' && (
                                <div className="install">
                                    <svg className="affirm" xmlns="http://www.w3.org/2000/svg" width="33" height="14" viewBox="0 0 33 14" fill="none">
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M2.14895 12.458C1.74493 12.458 1.53746 12.2608 1.53746 11.9363C1.53746 11.3327 2.21993 11.13 3.46366 10.9996C3.46366 11.8037 2.91223 12.457 2.14568 12.457L2.14895 12.458ZM2.68401 7.93387C1.79516 7.93387 0.773099 8.34673 0.218389 8.7833L0.725054 9.83969C1.17057 9.43762 1.88907 9.09375 2.53769 9.09375C3.15573 9.09375 3.49642 9.29748 3.49642 9.70818C3.49642 9.98306 3.27039 10.1232 2.84453 10.1782C1.25028 10.3819 0 10.8163 0 12.029C0 12.9906 0.693387 13.5716 1.7766 13.5716C2.5497 13.5716 3.23763 13.1479 3.56521 12.5906V13.4207H5.00658V9.94318C5.00658 8.5095 3.99871 7.93064 2.6851 7.93064L2.68401 7.93387ZM17.1523 8.09018V13.4153H18.6952V10.8497C18.6952 9.63057 19.4421 9.27161 19.963 9.27161C20.1978 9.26946 20.4271 9.33629 20.6225 9.46457L20.9053 8.05676C20.6868 7.97046 20.4528 7.92866 20.2174 7.93387C19.4247 7.93387 18.9256 8.2799 18.597 8.98488V8.09018H17.1523ZM28.0522 7.9328C27.2376 7.9328 26.6272 8.40925 26.3105 8.86738C26.0157 8.27451 25.3933 7.93387 24.6442 7.93387C23.8296 7.93387 23.264 8.38015 23.0041 8.89541V8.09018H21.5157V13.4142H23.0598V10.673C23.0598 9.69201 23.5817 9.21772 24.0687 9.21772C24.5099 9.21772 24.915 9.49798 24.915 10.2245V13.4142H26.4557V10.673C26.4557 9.67692 26.9657 9.21772 27.4745 9.21772C27.8829 9.21772 28.3153 9.50876 28.3153 10.2148V13.4142H29.8571V9.73298C29.8571 8.53645 29.0415 7.9328 28.0554 7.9328M13.3982 8.09018H12.0016V7.54904C12.0016 6.84406 12.4089 6.64356 12.7594 6.64356C12.9996 6.6468 13.2344 6.70501 13.4473 6.8128L13.9234 5.73916C13.9234 5.73916 13.4408 5.42871 12.564 5.42871C11.579 5.42871 10.4576 5.97739 10.4576 7.69888V8.09018H8.123V7.54904C8.123 6.84406 8.52921 6.64356 8.88082 6.64356C9.12104 6.64356 9.3569 6.70177 9.56874 6.8128L10.0437 5.73916C9.75983 5.57531 9.30449 5.42871 8.68536 5.42871C7.70042 5.42871 6.57899 5.97739 6.57899 7.69888V8.09018H5.68687V9.26407H6.58226V13.4142H8.12191V9.26407H10.4609V13.4142H12.0016V9.26407H13.3993V8.0891L13.3982 8.09018Z"
                                            fill="black"
                                        />
                                        <path d="M16.2861 8.14307H14.4766V13.5716H16.2861V8.14307Z" fill="black" />
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M14.4766 6.93893H15.9609C16.8273 4.03183 19.7659 1.47593 23.2591 1.47593C27.5091 1.47593 31.1808 4.93047 31.1808 10.3085C31.1937 11.4125 31.0517 12.5124 30.7594 13.5714H32.1997L32.2148 13.5186C32.4577 12.4696 32.577 11.3931 32.5716 10.3131C32.5716 4.31646 28.4786 0 23.2624 0C19.165 0 15.5127 3.03679 14.4776 6.94123L14.4766 6.93893Z"
                                            fill="#4A4AF4"
                                        />
                                    </svg>
                                    <span className="install-text">{t('install')}</span>
                                </div>
                            )} */}
                            <div className="links">
                                {/* {bundle?.link_more && (
                                    <Link
                                        className="link-more"
                                        href={bundle?.link_more}
                                        dataLayer={{
                                            event: 'uaEvent',
                                            event_name: 'buy',
                                            product_name: bundle.name,
                                            position: 'Product PreLaunch',
                                        }}
                                    >
                                        <a
                                            onClick={() => {
                                                createImgsCallbackLearnMore();
                                                return true;
                                            }}
                                        >
                                            {s('learn_more')}
                                        </a>
                                    </Link>
                                )} */}
                                {bundle?.inventory > 0 && bundle?.link_buy ? (
                                    <button className="link-buy" onClick={() => handleBuy(bundle)}>
                                        {s('buy_now')}
                                    </button>
                                ) : (
                                    <button disabled className="link-buy disable">
                                        {s('sold_out')}
                                    </button>
                                )}
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
            {showSteps && <InstallationPopup callInstallation={() => setShowSteps(false)} />}
        </div>
    );
}
